import * as types from './types';

const mutations = {
  // RESET
  [types.RESET](state) {
    state.company = {};
    state.missingInformation = [];
    state.contactPerson = {};
  },

  // FETCH_COMPANY
  [types.FETCH_COMPANY_PENDING](state) {
    state.fetchCompanyPending = true;
  },
  [types.FETCH_COMPANY_FULFILLED](state, { data }) {
    state.company = data.data;
    state.fetchCompanyPending = false;
  },
  [types.FETCH_COMPANY_ERROR](state) {
    state.fetchCompanyPending = false;
  },

  // STORE_COMPANY
  [types.STORE_COMPANY_PENDING](state) {
    state.storeCompanyPending = true;
  },
  [types.STORE_COMPANY_FULFILLED](state) {
    state.storeCompanyPending = false;
  },
  [types.STORE_COMPANY_ERROR](state) {
    state.storeCompanyPending = false;
  },

  // FETCH_LOCATION
  [types.FETCH_LOCATION_PENDING](state) {
    state.fetchLocationPending = true;
  },
  [types.FETCH_LOCATION_FULFILLED](state) {
    state.fetchLocationPending = false;
  },
  [types.FETCH_LOCATION_ERROR](state) {
    state.fetchLocationPending = false;
  },

  // CHECK_COMPANY_PROFILE
  [types.CHECK_COMPANY_PROFILE_PENDING](state) {
    state.checkCompanyProfilePending = true;
  },
  [types.CHECK_COMPANY_PROFILE_FULFILLED](state, { missing }) {
    state.missingInformation = missing;
    state.profileCompleted = missing.length === 0;
    state.checkCompanyProfilePending = false;
  },
  [types.CHECK_COMPANY_PROFILE_ERROR](state) {
    state.checkCompanyProfilePending = false;
  },

  // FETCH_CONTACT_PERSON
  [types.FETCH_CONTACT_PERSON_PENDING](state) {
    state.fetchContactPersonPending = true;
  },
  [types.FETCH_CONTACT_PERSON_FULFILLED](state, { data }) {
    state.contactPerson = data.data;
    state.fetchContactPersonPending = false;
  },
  [types.FETCH_CONTACT_PERSON_ERROR](state) {
    state.fetchContactPersonPending = false;
  },

  // STORE_CONTACT_PERSON
  [types.STORE_CONTACT_PERSON_PENDING](state) {
    state.storeContactPersonPending = true;
  },
  [types.STORE_CONTACT_PERSON_FULFILLED](state) {
    state.storeContactPersonPending = false;
  },
  [types.STORE_CONTACT_PERSON_ERROR](state) {
    state.storeContactPersonPending = false;
  },
};

export default mutations;
